import { all, takeEvery, put, fork } from "redux-saga/effects"
import { push } from "redux-first-history"

import * as actionTypes from "../actions/actionTypes"
import * as actions from "../actions/index"
import * as API from "../api"
import { toast } from "react-toastify"
import _ from "lodash"

export function* login() {
  yield takeEvery(actionTypes.REQUEST_LOGIN, function* (action) {
    yield put(actions.loading(true))

    try {
      const response = yield API.login(action.data)

      if (response.data.token) {
        yield put(actions.loginSuccess(response.data))
        // yield put(push("/"))
      } else {
        alert("Warning: Fail to login. " + response.data.message)
        yield put(actions.loginFail())
      }
      yield put(actions.loading(false))
    } catch (error) {
      if (error.status === 422) {
        yield put(actions.loginFail(error.data))
        toast.error(`Error: ${error.data.message}`)
      } else if (
        error.status === 400 ||
        error.status === 403 ||
        error.status === 401
      ) {
        yield put(actions.loginFail({ message: error.data.message }))
        toast.error(`Error: ${error.data.message}`)
      } else if (error.status === 404) {
        yield put(actions.loginFail({ message: error.data.message }))
        toast.error(`Error: ${error.data.message}`)
      } else yield put(actions.loginFail())
      yield put(actions.loading(false))
    }
  })
}

export function* verifyLogin2FA() {
  yield takeEvery(actionTypes.REQUEST_VERIFY_LOGIN_2FA, function* (action) {
    yield put(actions.loading(true))

    try {
      const response = yield API.verifyLogin2FA(action.data)
      if (response.data.success === true) {
        yield put(actions.verifyLogin2FASuccess(response.data))
        yield put(push("/"))
      } else {
        alert("Warning: Fail to login. " + response.data.message)
        yield put(actions.verifyLogin2FAFail())
      }
      yield put(actions.loading(false))
    } catch (error) {
      if (error.status === 422) {
        yield put(actions.verifyLogin2FAFail(error.data))

        if (_.isString(error.data.error)) {
          toast.error(`Error: ${error.data.error}`)
        }
      } else if (
        error.status === 400 ||
        error.status === 403 ||
        error.status === 401
      ) {
        yield put(actions.verifyLogin2FAFail({ message: error.data.error }))
        toast.error(`Error: ${error.data.error}`)
      } else if (error.status === 404) {
        yield put(actions.verifyLogin2FAFail({ message: error.data.error }))
        toast.error(`Error: ${error.data.error}`)
      } else yield put(actions.verifyLogin2FAFail())
      yield put(actions.loading(false))
    }
  })
}

export function* logout() {
  yield takeEvery(actionTypes.REQUEST_LOGOUT, function* () {
    yield put(actions.loading(true))

    try {
      const response = yield API.logout()

      if (response.status === 200) {
        yield put(actions.logoutSuccess())
        yield put(push("/"))
      } else {
        alert("Warning: Fail to logout. " + response.data.message)
        yield put(actions.logoutFail())
      }
      yield put(actions.loading(false))
    } catch (error) {
      yield put(actions.logoutFail())
      yield put(actions.loading(false))
    }
  })
}

export default function* authSaga() {
  yield all([fork(login), fork(verifyLogin2FA), fork(logout)])
}
